var _rect, _path, _path2, _circle, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTrianglePopover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.79883,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#FEEFC6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93857 17.3489C4.61648 16.7749 4.616 16.0729 4.95813 15.4967L4.95887 15.4954L10.4207 6.39742C10.7591 5.84532 11.3362 5.5 12.0039 5.5C12.6715 5.5 13.2487 5.84533 13.587 6.39743L13.5887 6.40009L19.0345 15.4967C19.3732 16.0671 19.3955 16.7715 19.0514 17.3536C18.7281 17.9259 18.1331 18.2878 17.4643 18.2878H6.54348C5.88196 18.2878 5.26559 17.9469 4.93857 17.3489ZM11.7181 7.17621L6.25597 16.2747C6.19601 16.3721 6.18885 16.5022 6.2537 16.6319C6.2981 16.7207 6.39056 16.7828 6.54348 16.7828H17.4492C17.5679 16.7828 17.6839 16.7191 17.7518 16.6088C17.803 16.5257 17.81 16.4047 17.7331 16.2687L12.2905 7.17765C12.2184 7.06132 12.1144 7.00504 12.0039 7.00504C11.8822 7.00504 11.7871 7.05561 11.7213 7.17064L11.7181 7.17621Z",
    fill: "#DC6803"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4062 10.1279C11.4062 9.78864 11.6695 9.52539 12.0088 9.52539C12.348 9.52539 12.6113 9.78864 12.6113 10.1279V13.2955C12.6113 13.6348 12.348 13.8981 12.0088 13.8981C11.6695 13.8981 11.4062 13.6348 11.4062 13.2955V10.1279Z",
    fill: "#DC6803"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9995,
    cy: 15.0659,
    r: 0.605,
    fill: "#DC6803"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.79883,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "#FEEFC6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTrianglePopover);
export default __webpack_public_path__ + "static/media/alert-triangle-popover.cd13761639d48d51283d1a3c9390bd9c.svg";
export { ForwardRef as ReactComponent };